export const currency = '$';
export const currentYear = new Date().getFullYear();
export const developedByLink = 'https://guruusoftware.com/';
export const developedBy = 'Guruu Software';
export const contactUs = 'contact@guruusoftware.com';
export const buyLink = '';
export const basePath = '';
export const DEFAULT_PAGE_TITLE = 'Sanduk Admin Panel';
export const colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'purple', 'pink', 'orange', 'light', 'link'];
